import { render, staticRenderFns } from "./Textlinks.vue?vue&type=template&id=00399fb2&"
import script from "./Textlinks.vue?vue&type=script&lang=js&"
export * from "./Textlinks.vue?vue&type=script&lang=js&"
import style0 from "./Textlinks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports